import { formatMs } from "@/utils/format";

export const getStratagemLabel = (entry, sort) => {
  if (sort === "speed" && entry.best_time_stratagem) return entry.best_time_stratagem.name;
  if (sort === "streak" && entry.best_streak_stratagem) return entry.best_streak_stratagem.name;
  if (entry.most_practiced) return entry.most_practiced.name;
  return "";
};

export const formatSortValue = (entry, sort) => {
  switch (sort) {
    case "accuracy": return `${entry.accuracy ?? entry.best_accuracy ?? 0}%`;
    case "speed": return formatMs(entry.best_time_ms);
    case "streak": return entry.longest_streak ?? entry.best_streak ?? 0;
    case "volume": return entry.successes;
    case "spm": return entry.best_spm ?? 0;
    case "completed": return entry.best_completed ?? 0;
    default: return "--";
  }
};

export const sortLabel = (sort) => {
  switch (sort) {
    case "accuracy": return "Accuracy";
    case "speed": return "Best Time";
    case "streak": return "Best Streak";
    case "volume": return "Drills Completed";
    case "spm": return "Stratagems/Min";
    case "completed": return "Most Completed";
    default: return "";
  }
};

export const PodiumMeta = ({ entry, sort, view }) => {
  const lines = [];
  if (view === "rapid_fire") {
    if (sort !== "accuracy") lines.push(`${entry.best_accuracy ?? entry.overall_accuracy ?? 0}% acc`);
    if (sort !== "streak") lines.push(`${entry.best_streak ?? 0} streak`);
    if (sort !== "completed") lines.push(`${entry.best_completed ?? 0} best session`);
    if (sort !== "spm") lines.push(`${entry.sessions ?? 0} sessions`);
  } else {
    if (sort !== "accuracy") lines.push(`${entry.accuracy}% acc`);
    if (sort !== "speed" && entry.best_time_ms) lines.push(formatMs(entry.best_time_ms));
    if (sort !== "streak") lines.push(`${entry.longest_streak ?? entry.best_streak ?? 0} streak`);
    if (sort !== "volume") lines.push(`${entry.successes} drills`);
  }

  const stratLabel = view === "overall" ? getStratagemLabel(entry, sort) : null;

  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs font-data text-gray-500 pt-1 border-t border-white/5">
      {lines.map((l) => <span key={l}>{l}</span>)}
      {stratLabel && (
        <span className="text-gray-600 italic truncate max-w-full">{stratLabel}</span>
      )}
    </div>
  );
};
